module.exports = __webpack_public_path__ + "static/gladyoufoundus-754dd14fa41917014b01a481c77c2e17.svg";